// Maket (no-backend) reporter identities. The host reads them synchronously in
// the mock branch, so they live beside it in lib/ instead of mocks/ (keeps the
// MSW fixture chunk out of the eager bundle, OPT-20261031-05). MSW handlers and
// tests import them through mocks/data/problem-reports/fixtures.ts.

export type ReportActor = {
  userId: string
  membershipId: string
  orgId: string
  shell: 'admin' | 'seller' | 'supply'
  canReview: boolean
  canManage: boolean
}

export const PROBLEM_REPORT_ACTORS: Record<string, ReportActor> = {
  sarah: {
    userId: '91000000-0000-4000-8000-000000000001',
    membershipId: '91000000-0000-4000-8000-000000000011',
    orgId: 'a1000000-0000-4000-8000-000000000001',
    shell: 'seller', canReview: false, canManage: false,
  },
  'sarah-colleague': {
    userId: '91000000-0000-4000-8000-000000000002',
    membershipId: '91000000-0000-4000-8000-000000000012',
    orgId: 'a1000000-0000-4000-8000-000000000001',
    shell: 'seller', canReview: false, canManage: false,
  },
  hakan: {
    userId: '92000000-0000-4000-8000-000000000001',
    membershipId: '92000000-0000-4000-8000-000000000011',
    orgId: 'a2000000-0000-4000-8000-000000000001',
    shell: 'supply', canReview: false, canManage: false,
  },
  reviewer: {
    userId: '90000000-0000-4000-8000-000000000001',
    membershipId: '90000000-0000-4000-8000-000000000011',
    orgId: 'a0000000-0000-4000-8000-000000000001',
    shell: 'admin', canReview: true, canManage: true,
  },
  'review-only': {
    userId: '90000000-0000-4000-8000-000000000002',
    membershipId: '90000000-0000-4000-8000-000000000012',
    orgId: 'a0000000-0000-4000-8000-000000000001',
    shell: 'admin', canReview: true, canManage: false,
  },
  'no-review': {
    userId: '90000000-0000-4000-8000-000000000003',
    membershipId: '90000000-0000-4000-8000-000000000013',
    orgId: 'a0000000-0000-4000-8000-000000000001',
    shell: 'admin', canReview: false, canManage: false,
  },
  'manage-only': {
    userId: '90000000-0000-4000-8000-000000000004',
    membershipId: '90000000-0000-4000-8000-000000000014',
    orgId: 'a0000000-0000-4000-8000-000000000001',
    shell: 'admin', canReview: false, canManage: true,
  },
}

PROBLEM_REPORT_ACTORS.so3_aybars = {
  userId: '92000000-0000-4000-8000-000000000002',
  membershipId: '92000000-0000-4000-8000-000000000012',
  orgId: 'a2000000-0000-4000-8000-000000000002',
  shell: 'supply', canReview: false, canManage: false,
}

PROBLEM_REPORT_ACTORS.so2_aybars = {
  userId: '92000000-0000-4000-8000-000000000003',
  membershipId: '92000000-0000-4000-8000-000000000013',
  orgId: 'a2000000-0000-4000-8000-000000000003',
  shell: 'supply', canReview: false, canManage: false,
}

PROBLEM_REPORT_ACTORS.so2_mehmet = {
  userId: '92000000-0000-4000-8000-000000000004',
  membershipId: '92000000-0000-4000-8000-000000000014',
  orgId: 'a2000000-0000-4000-8000-000000000004',
  shell: 'supply', canReview: false, canManage: false,
}

export const REPORT_SUPPLY_PERSONAS: Readonly<Record<string, string | undefined>> = {
  so3_aybars: 'so3_aybars', so2_aybars: 'so2_aybars', so2_mehmet: 'so2_mehmet', so2_hakan: 'hakan',
}
